import type { PropsWithChildren } from 'react';

export type PropertyListRootProps = PropsWithChildren;

export function PropertyListRoot({ children }: PropertyListRootProps) {
  return <dl className="flex flex-col gap-md">{children}</dl>;
}
PropertyListRoot.displayName = 'PropertyListRoot';
